module.exports = __webpack_public_path__ + "img/mahshev_no.8ca0e171.png";